import { useState, useCallback, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import MarketOverviewPage from "@/pages/MarketOverviewPage";
import DataExplorerPage from "@/pages/DataExplorerPage";
import PriceSignalsPage from "@/pages/PriceSignalsPage";
import PriceAlertsPage from "@/pages/PriceAlertsPage";
import FinancingPage from "@/pages/FinancingPage";
import TradeFlowPage from "@/pages/TradeFlowPage";
import AIIntelligencePage from "@/pages/AIIntelligencePage";
import AlertsPage from "@/pages/AlertsPage";
import GeospatialPage from "@/pages/GeospatialPage";
import PortfolioPage from "@/pages/PortfolioPage";
import WatchlistsPage from "@/pages/WatchlistsPage";
import HistoricalPage from "@/pages/HistoricalPage";
import AIAssistantPage from "@/pages/AIAssistantPage";
import NewsSentimentPage from "@/pages/NewsSentimentPage";
import { Sidebar } from "@/components/layout/Sidebar";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("auth_token");
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function AppLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className="app-layout">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <main className="main-content" style={{ marginLeft: collapsed ? 64 : 240 }}>
        {children}
      </main>
    </div>
  );
}

function AppContent() {
  const { theme } = useTheme();
  
  return (
    <div className={`min-h-screen bg-[#09090b] ${theme === 'light' ? 'light-theme' : 'dark-theme'}`}>
      <Toaster position="top-right" theme={theme} />
      <BrowserRouter>
        <Routes>
          <Route path="/welcome" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<ProtectedRoute><AppLayout><DashboardPage /></AppLayout></ProtectedRoute>} />
          <Route path="/market" element={<ProtectedRoute><AppLayout><MarketOverviewPage /></AppLayout></ProtectedRoute>} />
          <Route path="/explorer" element={<ProtectedRoute><AppLayout><DataExplorerPage /></AppLayout></ProtectedRoute>} />
          <Route path="/price-signals" element={<ProtectedRoute><AppLayout><PriceSignalsPage /></AppLayout></ProtectedRoute>} />
          <Route path="/price-alerts" element={<ProtectedRoute><AppLayout><PriceAlertsPage /></AppLayout></ProtectedRoute>} />
          <Route path="/financing" element={<ProtectedRoute><AppLayout><FinancingPage /></AppLayout></ProtectedRoute>} />
          <Route path="/trade-flow" element={<ProtectedRoute><AppLayout><TradeFlowPage /></AppLayout></ProtectedRoute>} />
          <Route path="/geospatial" element={<ProtectedRoute><AppLayout><GeospatialPage /></AppLayout></ProtectedRoute>} />
          <Route path="/intelligence" element={<ProtectedRoute><AppLayout><AIIntelligencePage /></AppLayout></ProtectedRoute>} />
          <Route path="/alerts" element={<ProtectedRoute><AppLayout><AlertsPage /></AppLayout></ProtectedRoute>} />
          <Route path="/portfolio" element={<ProtectedRoute><AppLayout><PortfolioPage /></AppLayout></ProtectedRoute>} />
          <Route path="/watchlists" element={<ProtectedRoute><AppLayout><WatchlistsPage /></AppLayout></ProtectedRoute>} />
          <Route path="/historical" element={<ProtectedRoute><AppLayout><HistoricalPage /></AppLayout></ProtectedRoute>} />
          <Route path="/ai-assistant" element={<ProtectedRoute><AppLayout><AIAssistantPage /></AppLayout></ProtectedRoute>} />
          <Route path="/news-sentiment" element={<ProtectedRoute><AppLayout><NewsSentimentPage /></AppLayout></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/welcome" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
